.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  align-items: center;
  padding: var(--tuna-spacing-4);
}

.verdictLine {
  font-size: var(--tuna-typography-h3-fontSize);
  font-weight: 600;
}

.correct {
  color: var(--tuna-feedback-success, var(--tuna-palette-success-main));
}

.incorrect {
  color: var(--tuna-feedback-warning-text, var(--tuna-palette-warning-main));
}

.comparison {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--tuna-spacing-4);
  width: 100%;
}

.voicingCard {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-subtle, var(--tuna-palette-grey-300));
  border-radius: var(--tuna-shape-borderRadius);
  padding: var(--tuna-spacing-3);
}

.voicingHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.voicingTitle {
  font-weight: 600;
}

.scoreBadge {
  font-family: var(--tuna-typography-mono-fontFamily, monospace);
  font-weight: 700;
  padding: 0 var(--tuna-spacing-1);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated, var(--tuna-palette-grey-100));
}

.explainer {
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-body2-fontSize);
  text-align: center;
  margin: 0;
}

@media (max-width: 599.95px) {
  .comparison {
    grid-template-columns: 1fr;
  }
}
